import { observable } from 'mobx';
import type { Moment } from '@this/lib/moment';
import moment from '@this/lib/moment';
import type ElementBaseInterface from './element_base_interface';

const insuranceProducts = {
  overseas_travel_accident: '海外旅行傷害保険'
};

export type InsuranceProductType = keyof typeof insuranceProducts;

export interface TravelAuthorizationElementArgs {
  id?: number;
  order_item_id?: number;
  product?: InsuranceProductType;
  content?: string;
  startedAt?: Moment;
  endedAt?: Moment;
}

/**
 * @deprecated
 * js/src/domain/insurance_element2.ts を使用すること
 */
export default class InsuranceElement implements ElementBaseInterface {
  readonly id?: number;

  readonly type: string;

  orderItemId?: number;

  @observable product?: InsuranceProductType;
  @observable content: string;
  @observable startedAt: Moment;
  @observable endedAt: Moment;

  constructor(args: TravelAuthorizationElementArgs) {
    this.id = args.id;
    this.type = 'insurance';
    this.orderItemId = args.order_item_id;
    this.product = args.product;
    this.content = args.content || '';
    this.startedAt = args.startedAt ? moment(args.startedAt) : moment();
    this.endedAt = args.endedAt ? moment(args.endedAt) : moment();
  }

  title() {
    return '保険';
  }

  startDate() {
    return null;
  }

  endDate() {
    return null;
  }

  description() {
    return `<${this.title()}>
    ■商品：${this.product && insuranceProducts[this.product]}
    ■内容
    ${this.content}
    ■開始日時：${this.startedAt.format('YYYY/MM/DD HH:mm:ss')}
    ■終了日時：${this.endedAt.format('YYYY/MM/DD HH:mm:ss')}
    `;
  }

  summary() {
    return `[保険] ${this.product && insuranceProducts[this.product]}`;
  }

  detail(_orderItem: unknown = undefined, _opts: unknown = undefined) {
    return '';
  }

  structuredDetail(_orderItem: unknown = undefined, _opts: unknown = undefined) {
    return [];
  }

  mappingDescription() {
    return this.title();
  }

  setField<T extends keyof this>(name: T, value: this[T]) {
    this[name] = value;
    app.render();
  }

  validationErrors(): string[] {
    const errors = [];
    if (!this.product) errors.push(`${this.title()}の商品を入力してください`);
    if (!this.content) errors.push(`${this.title()}の内容を入力してください`);
    if (this.endedAt < this.startedAt) errors.push('終了日は開始日以降を指定してください');
    return errors;
  }

  updateParams() {
    return {
      type: this.type,
      order_item_id: this.orderItemId,
      product: this.product,
      content: this.content,
      started_at: this.startedAt ? moment(this.startedAt).format('YYYY-MM-DD HH:mm:ss') : null,
      ended_at: this.endedAt ? moment(this.endedAt).format('YYYY-MM-DD HH:mm:ss') : null
    };
  }
}
